window.addEventListener('load', function () {
    let isSwiperVisible;
    let headerHeight = 0;
    let sectionPadding = 0;
    let ww = window.innerWidth;
    let mySwiper = undefined;

    setHeaderHeight();

    if (ww >= 767) {
        createSwiper();
    }

    function setHeaderHeight() {
        const headerGroupElements = document.querySelector('.sticky-header.site-header.show')
            ? document.querySelectorAll('.sticky-header.site-header.show')
            : document.querySelectorAll('.shopify-section-group-header-group');

        headerHeight = 0;
        headerGroupElements.forEach((element) => {
            headerHeight += element.offsetHeight;
        });
        if (document.querySelector('.sticky-header.site-header.show')) {
            sectionPadding = headerHeight;
        } else {
            sectionPadding = 0;
        }

        document.body.style.setProperty('--header-height', `${headerHeight}px`);
        document.body.style.setProperty('--fp-section-padding', `${sectionPadding}px`);
    }

    function createSwiper() {
        const allChildrenElements = document.querySelectorAll('#main > .shopify-section');
        const swiperElement = document.createElement('div');
        swiperElement.classList.add('swiper-container');
        const swiperWrapper = document.createElement('div');
        swiperWrapper.classList.add('swiper-wrapper');
        swiperElement.appendChild(swiperWrapper);

        allChildrenElements.forEach((element) => {
            const swiperSlide = document.createElement('div');
            swiperSlide.classList.add('swiper-slide');
            swiperSlide.appendChild(element);
            swiperWrapper.appendChild(swiperSlide);
        });

        document.querySelector('#main').appendChild(swiperElement);

        mySwiper = new Swiper('.swiper-container', {
            speed: 1000,
            direction: 'vertical',
            mousewheel: true,
            pagination: false,
            watchOverflow: true,
            on: {
                slideChange: function () {
                    setHeaderHeight();

                    setTimeout(function () {
                        if (mySwiper) {
                            mySwiper.params.touchReleaseOnEdges = false;
                            mySwiper.params.mousewheel.releaseOnEdges = false;
                        }
                    });
                },
                reachEnd: function () {
                    setTimeout(function () {
                        if (mySwiper) {
                            mySwiper.params.touchReleaseOnEdges = true;
                            mySwiper.params.mousewheel.releaseOnEdges = true;
                        }
                    }, 500);
                },
                reachBeginning: function () {
                    setTimeout(function () {
                        if (mySwiper) {
                            mySwiper.params.touchReleaseOnEdges = true;
                            mySwiper.params.mousewheel.releaseOnEdges = true;
                        }
                    }, 500);
                },
            },
        });
    }

    const swiperObserver = new IntersectionObserver((entries) => {
        isSwiperVisible = entries[0].intersectionRatio >= 0.99;

        if (!isSwiperVisible && mySwiper) {
            mySwiper.disable();
            document.querySelector('.swiper-container').style.pointerEvents = 'none';
        } else if (mySwiper) {
            mySwiper.enable();
            document.querySelector('.swiper-container').style.pointerEvents = 'inherit';
        }
    });

    window.addEventListener('scroll', () => {
		if(ww < 767) return;
        setTimeout(() => {
            swiperObserver.unobserve(document.querySelector('.swiper-container'));
            swiperObserver.observe(document.querySelector('.swiper-container'));
            setHeaderHeight();
        }, 500);
    });

    window.addEventListener('resize', function () {
        setTimeout(() => {
            const newWidth = window.innerWidth;
            if (newWidth !== ww) {
                ww = newWidth;
                if (ww >= 767 && !mySwiper) {
                    createSwiper();
                } else if (ww < 767 && mySwiper) {
                    mySwiper.destroy();
                    mySwiper = undefined;
                    document.querySelector('.swiper-container').remove();
                }
            }
        }, 500);
    });

	if (ww >= 767) {
		swiperObserver.observe(document.querySelector('.swiper-container'));
    }
});
